module.exports = __webpack_public_path__ + "static/media/WezeshaHub.bf00c777.webp";